var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from "@tanstack/react-query";
import { object, uuidv4 } from "decoders";
import { throwAPIError } from "~/client/errors";
import useSafelyParseJsonResponse from "~/client/hooks/useSafelyParseJsonResponse";
import fetch from "~/client/utils/fetch";
const authenticateResponseDecoder = object({
    userId: uuidv4,
});
export const getQueryKey = () => ["/authenticate"];
const useAuthenticateMe = () => {
    const parseJson = useSafelyParseJsonResponse();
    return useMutation({
        mutationFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch("/authenticate", { method: "POST" });
            if (!response.ok) {
                yield throwAPIError(response);
            }
            const responseJson = yield parseJson(response);
            try {
                const { userId } = authenticateResponseDecoder.verify(responseJson);
                return userId;
            }
            catch (_a) {
                throw new Error("Error authenticating user.");
            }
        }),
    });
};
export default useAuthenticateMe;
